import { Subcategory } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const SUBCATEGORY_FIND = createAction('[Subcategory] Find');
export const SUBCATEGORY_FIND_SUCCESS = createAction('[Subcategory] Find Success', props<{ subcategory: Subcategory | null }>());
export const SUBCATEGORY_FAILED = createAction('[Subcategory] Failed', props<{ error: string }>());
export const SUBCATEGORY_UPDATE_LOADING = createAction('[Subcategory] Update Loading', props<{ loading: boolean }>());
export const SUBCATEGORY_UPDATE_ID = createAction('[Subcategory] Update Id', props<{ subcategoryId: string| null }>());
export const SUBCATEGORY_FIND_ALL_SUCCESS = createAction('[Subcategory] Find Success All', props<{ subcategoryList: Subcategory[] }>());
export const SUBCATEGORY_CLEAR_STATE = createAction('[Subcategory] Clear State');
